(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.ActionHandlers;

    (function (ActionHandlers, $, undefined) {
        /**
         * @memberOf Lfl.ActionHandlers
         */
        Lfl.ActionHandlers.OnDragHandlers;

        (function (OnDragHandlers, $, undefined) {
            if (Lfl.Files.isLoadedAlready(Lfl.ActionHandlers.OnDragHandlers, 'ModalOdhButtonDescriptor')) {
                return;
            }


            /*
             |===========================================================================================================
             | Class definition
             |===========================================================================================================
             */

            /**
             * Describes the behaviour of a button in the dialogue opened by an ODH.
             *
             * @See the PHP counterpart ModalOdhButtonDescriptor.php for more info.
             * @param {{}} parameters
             * @param {string} parameters.buttonPath A DOM path that identifies the button.
             * @param {boolean} parameters.dragAllowed Whether drag is allowed (the user action is performed) when this
             * button is selected. If false then the drag will be reverted.
             * @param {{}} parameters.dragSavingData An object containing key-value pairs that will be sent back to the
             * server when the component data is saved if this button is selected. Can be used to let the server know
             * that certain drag has a specific semantic meaning (for example a change of starting time for this day
             * only vs. for all future days).
             *
             *
             * @memberOf Lfl.ActionHandlers.OnDragHandlers
             * @lends Lfl.ActionHandlers.OnDragHandlers.ModalOdhButtonDescriptor
             * @constructor
             */
            Lfl.ActionHandlers.OnDragHandlers.ModalOdhButtonDescriptor = function (parameters) {
                /*
                 |-------------------------------------------------------------------------------------------------------------------
                 | Construction
                 |-------------------------------------------------------------------------------------------------------------------
                 */

                var $button = $(parameters.buttonPath);
                var dragAllowed = parameters.dragAllowed;
                var dragSavingData = parameters.dragSavingData;

                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Public methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

                /**
                 * Initializes the button action handling.
                 * @param {Lfl.ActionHandlers.OnDragHandlers.ModalOdh} odh
                 */
                this.init = function (odh) {
                    $button.click(function () {
                        if (dragAllowed === true) {
                            odh.confirm(dragSavingData);
                        } else {
                            odh.deny(dragSavingData);
                        }
                    });

                };


                /*
                 |-----------------------------------------------------------------------------------------------------------
                 | Private methods
                 |-----------------------------------------------------------------------------------------------------------
                 */

            };

        }(ActionHandlers.OnDragHandlers = ActionHandlers.OnDragHandlers || {}, jQuery));
    }(Lfl.ActionHandlers = Lfl.ActionHandlers || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));

